import React, { useEffect } from 'react';
import { Button } from 'antd';
import { useHistory } from 'react-router-dom';

import './ShipmentType.less';
import { usePackagingFlow } from '../../context/PackagingFlowContext';

const ShipmentType: React.FC = () => {
    const history = useHistory();
    const { setSelectedStore, reset } = usePackagingFlow();

    useEffect(() => {
        reset();
    }, [reset]);
    const handleBeforeLoadingClick = () => {
        setSelectedStore(null);
        reset();
        history.push('/before-loading');
    };

    const handleAfterLoadingClick = () => {
        setSelectedStore(null);
        reset();
        history.push('/after-loading');
    };

    return (
        <div className="expedition-type-page">
            <div className="shipmentTitle">
                <h2>Veuillez choisir le type d&apos;expedition</h2>
            </div>
            <Button className="expedition-button" block onClick={handleBeforeLoadingClick}>
                Avant le chargement
            </Button>
            <Button className="expedition-button" block onClick={handleAfterLoadingClick}>
                Après le chargement
            </Button>
        </div>
    );
};

export default ShipmentType;
